// assets/api-security.js

// CSRF-Token Management
const security = {
    csrfToken: null,

    async getCSRFToken() {
        if (this.csrfToken) return this.csrfToken;
        
        try {
            const response = await fetch('/admin/api/2024-01/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Access-Token': window.shopifyConfig?.accessToken
                },
                body: JSON.stringify({
                    query: `
                        query {
                            shop {
                                id
                            }
                        }
                    `
                })
            });

            const csrf = response.headers.get('x-csrf-token');
            if (csrf) {
                this.csrfToken = csrf;
                return csrf;
            }
            throw new Error('CSRF Token nicht gefunden');
        } catch (error) {
            console.error('CSRF Token Error:', error);
            throw error;
        }
    },

    // Füge CSRF-Token zu API-Requests hinzu
    async secureRequest(url, options = {}) {
        try {
            const token = await this.getCSRFToken();
            
            // Headers zusammenführen
            const headers = {
                ...options.headers,
                'X-CSRF-Token': token
            };

            // Request ausführen
            const response = await fetch(url, {
                ...options,
                headers
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return response;
        } catch (error) {
            console.error('Secure Request Error:', error);
            throw error;
        }
    }
};

// Mache security global verfügbar
window.security = security;